export default "__VITE_ASSET__4bddb9e8__"